import { $header, getCurrentDevice } from './utils';

export default function headerUI() {
	const $subNavs = $('.header__subnav');

	$header.find('.has-dropdown a').each(function(index) {
		const $this = $(this);
		const $sub = $subNavs.eq(index);

		$sub.data('anchor', $this);

		$this.on('mouseenter click', function() {
			$sub.addClass('active');

			toggleAnchorActive($this, true);
		}).on('mouseleave', function() {
			$sub.removeClass('active');

			toggleAnchorActive($this, false);
		});

		$this.on('click', function(event) {
			if (getCurrentDevice() !== 'desktop') {
				event.preventDefault();
			}
		})
	});

	$subNavs.on('mouseenter', function() {
		const $this = $(this);

		$this.addClass('active');

		toggleAnchorActive($this.data('anchor'), true);
	}).on('mouseleave', function() {
		const $this = $(this);

		$this.removeClass('active');

		toggleAnchorActive($this.data('anchor'), false);
	});

	$('.js-subnav-close').on('click', function() {
		const $subnav = $(this).closest('.active');

		$subnav.removeClass('active');

		toggleAnchorActive($subnav.data('anchor'), false);
	});

	function toggleAnchorActive($a, isActive) {
		$a.toggleClass('active', isActive);
	}
}
